import { Routes } from '@angular/router';
import { AuthGuard } from '@toteimlib/angular-lib';

export const appRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: (): Promise<any> => import('./components/dashboard/dashboard.routes').then((m: any): void => m.dashboardRoutes)
  },
  {
    path: '',
    loadChildren: (): Promise<any> => import('./components/guest/guest.routes').then((m: any): void => m.guestRoutes)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
